<div class="gap-[40px] flex flex-col vh-[calc(100vh-100px)] shrink-0 justify-start items-center pl-[120px] pr-[120px] pt-[40px] pb-[40px] bg-[#f8fafdff] w-[100%] relative font-archivo">
  <div *ngIf="isLoading" class="flex flex-col items-center justify-center w-full h-full gap-4">
    <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
    <span class="text-[#111215ff] font-archivo text-[18px]">Loading...</span>
  </div>

  <ng-container *ngIf="!isLoading">
    <div class="gap-[24px] flex flex-col w-[100%] shrink-0 justify-start items-start self-stretch">
      <button
        type="button"
        class="rounded-[999px] px-[24px] py-[10px] bg-white border border-gray-300 font-archivo text-[18px] cursor-pointer hover:bg-gray-50"
        (click)="onBack()"
      >
        Back to Staff List
      </button>

      <div *ngIf="errorMessage" class="text-red-600 font-archivo text-[18px]">
        {{ errorMessage }}
      </div>

      <div *ngIf="successMessage" class="text-green-600 font-archivo text-[18px]">
        {{ successMessage }}
      </div>

      <!-- View mode -->
      <ng-container *ngIf="mode === 'view' && staffDetail && !errorMessage">
        <div class="w-full bg-white rounded-lg border border-gray-200 p-8 flex flex-col gap-6">
          <div class="flex flex-col gap-1">
            <h1 class="font-archivo text-[28px] font-bold text-[#111215ff] m-0">
              {{ staffDetail.staffName }}
            </h1>
            <p class="font-archivo text-[1rem] text-gray-500 m-0">
              Last login: {{ formatDate(staffDetail.lastLogin) }}
            </p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <span class="staff-field-label">SF ID</span>
              <div class="staff-field-value">{{ staffDetail.sfId || '-' }}</div>
            </div>

            <div>
              <span class="staff-field-label">Staff Name</span>
              <div class="staff-field-value">{{ staffDetail.staffName || '-' }}</div>
            </div>

            <div>
              <span class="staff-field-label">Email</span>
              <div class="staff-field-value">{{ staffDetail.email || '-' }}</div>
            </div>

            <div>
              <span class="staff-field-label">Status</span>
              <div class="staff-field-value">{{ formatStatus(staffDetail.status) }}</div>
            </div>

            <div>
              <span class="staff-field-label">Created At</span>
              <div class="staff-field-value">{{ formatDate(staffDetail.createdAt) }}</div>
            </div>

            <div class="md:col-span-2">
              <span class="staff-field-label">Locations</span>
              <div class="staff-field-value">{{ formatLocations(staffDetail) }}</div>
            </div>
          </div>

          <div class="flex flex-row flex-wrap gap-4 items-center justify-end pt-4 border-t border-gray-200">
            <button
              type="button"
              class="rounded-[999px] px-[24px] py-[10px] bg-[#F26F24] text-white font-archivo text-[18px] font-semibold cursor-pointer hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed"
              (click)="onEdit()"
            >
              Edit Staff
            </button>

            <button
              *ngIf="staffDetail.status"
              type="button"
              class="rounded-[999px] px-[24px] py-[10px] bg-white border border-red-400 text-red-600 font-archivo text-[18px] cursor-pointer hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="isSaving"
              (click)="onDeactivate()"
            >
              Deactivate Staff
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Create / Edit mode -->
      <ng-container *ngIf="mode !== 'view' && !errorMessage">
        <form
          class="w-full bg-white rounded-lg border border-gray-200 p-8 flex flex-col gap-6 staff-form-fields"
          (ngSubmit)="onSubmit()"
        >
          <h1 class="font-archivo text-[28px] font-bold text-[#111215ff] m-0">
            {{ pageTitle }}
          </h1>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="staff-field-label" for="staff-sf-id">
                SF ID <span class="text-danger-500">*</span>
              </label>
              <input
                id="staff-sf-id"
                type="text"
                class="staff-form-input"
                [(ngModel)]="sfId"
                name="sfId"
                placeholder="Enter Salesforce ID"
                required
                autocomplete="off"
              />
            </div>

            <div>
              <label class="staff-field-label" for="staff-name">
                Staff Name <span class="text-danger-500">*</span>
              </label>
              <input
                id="staff-name"
                type="text"
                class="staff-form-input"
                [(ngModel)]="staffName"
                name="staffName"
                placeholder="Enter staff name"
                required
                autocomplete="off"
              />
            </div>

            <div>
              <label class="staff-field-label" for="staff-email">
                Email <span class="text-danger-500">*</span>
              </label>
              <input
                id="staff-email"
                type="text"
                class="staff-form-input"
                [(ngModel)]="email"
                name="staffEmail"
                placeholder="Enter email address"
                required
                autocomplete="off"
                spellcheck="false"
              />
            </div>
          </div>

          <div class="flex flex-col gap-2">
            <span class="staff-field-label">Status</span>
            <NiFormToggle
              label="Active"
              [(ngModel)]="status"
              name="status"
            />
          </div>

          <NiFormSelect
            label="Locations"
            [options]="locationOptions"
            valueField="value"
            stateField="label"
            placeholder="Select locations"
            [multiple]="true"
            [(ngModel)]="selectedLocationIds"
            name="locationIds"
          />

          <div class="flex flex-row flex-wrap gap-4 items-center justify-end pt-4 border-t border-gray-200">
            <button
              type="button"
              class="rounded-[999px] px-[24px] py-[10px] bg-white border border-gray-300 font-archivo text-[18px] cursor-pointer hover:bg-gray-50"
              (click)="onBack()"
            >
              Cancel
            </button>

            <button
              type="submit"
              class="rounded-[999px] px-[24px] py-[10px] bg-[#F26F24] text-white font-archivo text-[18px] font-semibold cursor-pointer hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="isSaving"
            >
              {{ mode === 'create' ? 'Create Staff' : 'Save Changes' }}
            </button>
          </div>
        </form>
      </ng-container>
    </div>
  </ng-container>
</div>
